export const animationConfig = {
  tension: 130,
  mass: 1,
  friction: 26,
  velocity: 0,
  precision: 0.01,
};
